<template>
  <div class="detail-page">
    <div class="detail-up-bg">
      <div class="mainBox">
        <dl class="clearfix">
          <dt class="big-img" v-if="carouselImages.length">
            <Carousel
              v-if="carouselImages.length > 1"
              autoplay
              v-model="carouselValue"
              loop
              :height="288"
              :autoplay-speed="5000"
              dots="inside"
              arrow="hover"
            >
              <CarouselItem
                v-for="(img, index) in carouselImages"
                :key="index"
              >
                <div class="detail-carousel-item">
                  <img :src="imgurl + img" alt="" />
                </div>
              </CarouselItem>
            </Carousel>
            <div v-else class="detail-carousel-item">
              <img :src="imgurl + carouselImages[0]" alt="" />
            </div>
          </dt>
          <dd class="detail-rig">
            <h2>{{ detailData.course }}</h2>
            <ul class="line-list clearfix">
              <li><i>授课老师：</i>{{ detailData.teacher }}</li>
              <li class="matter">
                <i>上课时间：</i>{{ detailData.classBegin }}
              </li>
              <li class="matter"><i>开课时间：</i>{{ detailData.beginDt }}</li>
              <li class="matter"><i>授课次数：</i>{{ detailData.times }}</li>
              <li class="matter">
                <i>报名时间：</i>
                <p v-for="(period, index) in detailData.signUpPeriod" :key="index">
                  {{ period }}
                </p>
              </li>
              <li class="matter">
                <i>老学员报名时间：</i>
                <p v-for="(period, index) in detailData.signUpOldStudentPeriod" :key="index">
                  {{ period }}
                </p>
              </li>
              <li class="matter">
                <i>校内退休人员报名时间：</i>
                <p v-for="(period, index) in detailData.signUpOurStudentPeriod" :key="index">
                  {{ period }}
                </p>
              </li>
              <li class="matter">
                <i>校外人员报名时间：</i>
                <p v-for="(period, index) in detailData.signUpOutsideStudentPeriod" :key="index">
                  {{ period }}
                </p>
              </li>
              <li><i>年龄上限：</i>{{ detailData.age }}</li>
              <li v-if="detailData.year">
                <i>学期：</i>{{ detailData.year.substr(0, 4)
                }}{{ detailData.year.substr(4, 5) == 1 ? "春季" : "秋季" }}
              </li>
              <li><i>校区：</i>{{ detailData.campusName }}</li>
              <li><i>教室：</i>{{ detailData.address }}</li>
              <li class="amount">
                <i>学费：</i><span>￥</span>{{ detailData.amount }}
              </li>
            </ul>
            <div style="display: block">
              <Button
                :disabled="viewApply"
                type="info"
                @click="applyConfirm(detailData.id, detailData.course)"
                style="margin-top: 10px; padding: 8px 30px; font-size: 26px; letter-spacing: 2px; width: 206px; height: 60px;"
              >立即报名</Button>
            </div>
          </dd>
        </dl>
      </div>
    </div>
    <div class="mainBox">
      <h1 class="detail-con-title"><span>课程介绍</span></h1>
      <div class="detail-con-text">{{ detailData.courseDescribe }}</div>
    </div>
    <apply-flow ref="applyFlow"></apply-flow>
  </div>
</template>
<script>
import applyFlow from "_c/applyFlow.vue"

export default {
  data() {
    return {
      detailData: [],
      viewApply: true,
      carouselValue: 0,
    };
  },
  computed: {
    carouselImages() {
      const list = [];
      if (this.detailData.pictureSrc) {
        list.push(this.detailData.pictureSrc);
      }
      if (this.detailData.imageNames) {
        this.detailData.imageNames
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s)
          .forEach((s) => list.push(s));
      }
      return list;
    },
  },
  filters: {
    filtersYear(val) {
      return val.substr(4, 5) == 1 ? "春季" : "秋季";
    },
  },
  components: {
    applyFlow,
  },
  methods: {
    applyConfirm(id, name) {
      this.$refs.applyFlow.applyConfirm(id, name);
    },

    getData() {
      var _this = this;
      _this.$http
        .get("retire-school-manage/course/getCourseById", {
          params: {
            id: _this.$route.query.id,
            sid: _this.$route.query.sid,
            studentId: _this.$store.state.studentId,
            courseNo: _this.$route.query.courseNo,
            // phone:_this.$route.query.phone,
            year: _this.$route.query.year,
            xq: _this.$route.query.xq,
          },
        })
        .then(function (res) {
          if (res.data.status === 2000) {
            var convertDtArray = (obj) => {
              console.log("convertDtArray", obj);
              if (obj.split("~").length == 2) {
                //console.log("convertDtArray", obj.split("~"));
                return (
                  new Date(Number(obj.split("~")[0]) + 8 * 3600 * 1000)
                    .toISOString()
                    .substring(0, 16)
                    .replace("T", " ") +
                  "~" +
                  new Date(Number(obj.split("~")[1]) + 8 * 3600 * 1000)
                    .toISOString()
                    .substring(0, 16)
                    .replace("T", " ")
                );
              } else {
                return "暂无数据";
              }
            };
            _this.detailData = res.data.data;
            if (res.data.data.signUpPeriod == null)
              res.data.data.signUpPeriod = "";
            if (res.data.data.signUpOldStudentPeriod == null)
              res.data.data.signUpOldStudentPeriod = "";
            if (res.data.data.signUpOurStudentPeriod == null)
              res.data.data.signUpOurStudentPeriod = "";
            if (res.data.data.signUpOutsideStudentPeriod == null)
              res.data.data.signUpOutsideStudentPeriod = "";
            if (res.data.data.signUpOtherStudentPeriod == null)
              res.data.data.signUpOtherStudentPeriod = "";

            if (!_this.detailData.age) {
              _this.detailData.age = "无";
            }

            _this.detailData.signUpPeriod = res.data.data.signUpPeriod
              .split(",")
              .map(convertDtArray);
            _this.detailData.signUpOldStudentPeriod =
              res.data.data.signUpOldStudentPeriod
                .split(",")
                .map(convertDtArray);
            _this.detailData.signUpOurStudentPeriod =
              res.data.data.signUpOurStudentPeriod
                .split(",")
                .map(convertDtArray);
            _this.detailData.signUpOutsideStudentPeriod =
              res.data.data.signUpOutsideStudentPeriod
                .split(",")
                .map(convertDtArray);
            _this.detailData.signUpOtherStudentPeriod =
              res.data.data.signUpOtherStudentPeriod
                .split(",")
                .map(convertDtArray);
            _this.viewApply = false;
            if (_this.$store.state.studentId) {
              if (
                _this.detailData.signUpCnt == _this.detailData.courseNumber ||
                _this.detailData.flag == "N"
              ) {
                _this.viewApply = true;
              } else {
                _this.viewApply = false;
              }
            }
          } else if (res.data.status === 9000) {
            _this.detailData = [];
          } else {
            _this.$CustomMessageError(res.data.msg);
          }
          if (_this.$store.state.studentId) {
            _this.getUserInfo(
              _this.detailData.flag,
              _this.detailData.errorReason
            );
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getUserInfo(flag, reason) {
      var _this = this;
      _this.$http
        .get("retire-school-manage/personal/getMyInfo", {
          params: {
            studentId: _this.$store.state.studentId,
          },
        })
        .then((res) => {
          if (res.data.status == 2000) {
            if (res.data.data.payEndDate == null) {
              _this.resolution = "1";
            }
          } else {
            console.log("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });

      if (flag == "N") {
        _this.viewApply = true;
        _this.$CustomMessageWarn(reason);
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
<style lang="less">
@import "../../styles/detail.less";
</style>
